import { render, staticRenderFns } from "./BaseTableData.vue?vue&type=template&id=437a43cc&scoped=true&"
import script from "./BaseTableData.vue?vue&type=script&lang=js&"
export * from "./BaseTableData.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableData.vue?vue&type=style&index=0&id=437a43cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a43cc",
  null
  
)

export default component.exports